import React from "react";
import { AppRouter } from "./navigation";
import { ToastProvider } from "./providers";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SocketProvider } from "./providers/AuthProviders";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SocketProvider>
        <ToastProvider>
          <AppRouter />
        </ToastProvider>
      </SocketProvider>
    </QueryClientProvider>
  );
}

export default App;
